import { VListItem } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.miniVariant ? _c(VListItem, {
    staticClass: "pb-2",
    attrs: {
      "id": "drawer-header"
    }
  }, [_c('router-link', {
    staticClass: "logo-container-link",
    attrs: {
      "to": _vm.sidebarIconLink
    }
  }, [_c('div', {
    class: `logo-container ${_vm.orientation}`
  }, [!_vm.hasDefaultLogo ? _c('div', {
    staticClass: "logo-image",
    style: `background-image: url(${_vm.logo})`
  }) : _vm._e(), _vm.hasDefaultLogo ? _c('div', {
    staticClass: "logo-image"
  }, [_c('core-logo-niotix', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "margin-top": "10px"
    },
    attrs: {
      "dark": _vm.UiTheme,
      "color": _vm.color
    }
  })], 1) : _vm._e()])])], 1) : _c('router-link', {
    staticClass: "pb-2",
    attrs: {
      "to": _vm.sidebarIconLink
    }
  }, [_c('div', {
    staticClass: "miniVariant-header text-center"
  }, [_vm.hasDefaultLogo ? _c('div', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('core-logo-niotix', {
    staticStyle: {
      "width": "100%",
      "height": "36px"
    },
    attrs: {
      "dark": _vm.UiTheme,
      "color": _vm.color,
      "mini": ""
    }
  })], 1) : _c('div', {
    staticClass: "letter-wrapper drawer-header-letter"
  }, [_vm._v("\n      " + _vm._s(_vm.specLetter) + "\n    ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };